import styled, { css } from "styled-components";
import { IconButton, TabList } from "@similarweb/ui-components";
import { colorsPalettes, mixins } from "@similarweb/styles";
import { CenteredFlexRow, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface IDisableable {
    isDisabled?: boolean;
}
export const EndCellContainer = styled(FlexRow)`
    width: 100%;
    justify-content: space-between;
`;
export const KeywordsCountContainer = styled(FlexRow)`
    margin-right: 8px;
`;
export const StyledEnrichButtonText = styled.div<IDisableable>`
    ${(props) =>
        mixins.setFont({
            $size: 10,
            $weight: 700,
            $color: colorsPalettes.carbon[props.isDisabled ? 100 : 300],
        })}
`;

export const StyledEnrichButton = styled(IconButton)<IDisableable>`
    background: ${colorsPalettes.carbon[0]};
    padding: 0 8px;
    border-radius: 4px;
    border: 1px solid ${colorsPalettes.carbon[50]};

    > .SWReactIcons > svg > path {
        fill: ${(props) => colorsPalettes.carbon[props.isDisabled ? 100 : 300]};
    }

    ${(props) =>
        !props.isDisabled &&
        css`
            &:hover {
                border: 1px solid ${colorsPalettes.midnight[100]} !important;
                color: ${colorsPalettes.carbon[0]};
            }
        `}
`;

export const TabListStyled = styled(TabList)`
    margin-bottom: 0;
`;

// tabletop styles
const Container = styled(CenteredFlexRow)`
    padding: 12px 16px 12px 24px;
    justify-content: space-between;
`;
const DownloadExcelContainer = styled.span`
    margin: 0 8px 0 16px;
`;

export const ChipdownItem = styled(FlexRow)`
    flex-grow: 0;
`;
